import { render, staticRenderFns } from "./DropZoneTableGroup.vue?vue&type=template&id=47b40eda&"
import script from "./DropZoneTableGroup.vue?vue&type=script&lang=js&"
export * from "./DropZoneTableGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports